import { PackageType } from '../../../../shared/components/Card/ReviewCard';

export const reviewCards = [
    {
        design: {
            url: 'product-landing/reviews/review-design-01.jpeg',
            designerName: 'DenjakArt',
        },
        clientReview: {
            rating: 5,
            review: 'The logo contest was amazing; within a few days of posting the brief I received over 70 quality options to choose from. Designers were accommodating and happy to make changes when requested. I like the security of the designer knowing payment has been made, but will not be released until we are happy with the end result. Very professional environment and an overall great experience',
        },
        client: {
            id: '1435198',
            displayName: 'Alberta Soccer',
        },
        contest: {
            title: 'Alberta Soccer',
            description:
                'Alberta Soccer is the governing body for soccer in Alberta. Stimulating competition, optimum performance, safe and fun for all.',
            entriesTotal: 71,
            designersTotal: 16,
            url: '/logo-design/contests/alberta-soccer-provincials-logo-970097',
            packageType: 'BRONZE' as PackageType,
        },
    },
    {
        design: {
            url: 'product-landing/reviews/review-design-02.jpeg',
            designerName: 'saingrafis',
        },
        clientReview: {
            rating: 5,
            review: 'Good communication with designer and quick responses on my requests. Very satisfied!',
        },
        client: {
            id: '3921283',
            displayName: 'bjvolden',
        },
        contest: {
            title: 'Cyclocross Spikkestadkross',
            description:
                'Designing a new logo for the National championship in Cyclocross Spikkestadkross.',
            entriesTotal: 70,
            designersTotal: 19,
            url: '/logo-design/contests/design-killer-logo-national-championship-cyclocross-spikkestadkross-952454',
            packageType: 'BRONZE' as PackageType,
        },
    },
    {
        design: {
            url: 'product-landing/reviews/review-design-03.jpeg',
            designerName: 'Magneticways',
        },
        clientReview: {
            rating: 5,
            review: 'An amazing experience for low cost. My designer listened to my needs and came back with a design ten fold of what I expected. Thank you 99designs',
        },
        client: {
            id: '3912302',
            displayName: 'maynarddogtraining',
        },
        contest: {
            title: 'Maynard Dog Training Solutions',
            description:
                'We help train dogs and keep them in homes rather than in jail (shelter). We help dogs behave for their owners.',
            entriesTotal: 38,
            designersTotal: 18,
            url: '/logo-design/contests/help-raise-awareness-money-shelter-animals-950960',
            packageType: 'BRONZE' as PackageType,
        },
    },
    {
        design: {
            url: 'product-landing/reviews/review-design-04.jpeg',
            designerName: 'April Anny',
        },
        clientReview: {
            rating: 5,
            review: 'A fabulous way to get a fast, creative design for your business no matter where you are in the world.',
        },
        client: {
            id: '3906403',
            displayName: 'donnamus28',
        },
        contest: {
            title: 'Lucky Star Farm',
            description:
                'We are a small organic, sustainable wilderness farm in the Ozark Mountains with an artist residency program.',
            entriesTotal: 76,
            designersTotal: 19,
            url: '/logo-design/contests/design-modern-logo-wilderness-farm-artist-residency-program-949847',
            packageType: 'BRONZE' as PackageType,
        },
    },
    {
        design: {
            url: 'product-landing/reviews/review-design-05.jpeg',
            designerName: 'EnricoMalatesta',
        },
        clientReview: {
            rating: 5,
            review: 'I truly enjoyed the process from beginning to end. The customer service was impeccable and the work with designers was super fun and they really brought my vision to life! Thank you SO much!',
        },
        client: {
            id: '4208175',
            displayName: 'iamawakenedbear',
        },
        contest: {
            title: 'Awakened Bear',
            description:
                'Helping people on their spiritual path to supercharge their health, wealth & relationships through embodiment coaching.',
            entriesTotal: 80,
            designersTotal: 16,
            url: '/logo-design/contests/awakened-bear-wake-up-world-supercharged-logo-1003061',
            packageType: 'BRONZE' as PackageType,
        },
    },
    {
        design: {
            url: 'product-landing/reviews/review-design-06.jpeg',
            designerName: 'SplashThemes',
        },
        clientReview: {
            rating: 5,
            review: 'Great Experience. I have created several national brands in the past at great expense and effort. This was effortless, fast, fun and inexpensive. I highly recommend it. Will change how this is done in the future!',
        },
        client: {
            id: '4217874',
            displayName: 'bruce.bond',
        },
        contest: {
            title: 'Council Hill Vineyards',
            description:
                'Council Hill is in the Upper Mississippi River Valley AVA and in the Driftless Region.',
            entriesTotal: 174,
            designersTotal: 25,
            url: '/logo-design/contests/council-hill-vineyards-1004477',
            packageType: 'GOLD' as PackageType,
        },
    },
];
